import { get, isEqual } from 'lodash';

export const PENDING_AUTHORIZATION_CASE_ACCESS_MESSAGE = [
  'You can\'t access cases that are pending authorization.',
  'Try again later.',
].join(' ');

export const PENDING_AUTHORIZATION_CASE_ACCESS_TIMEOUT_MS = 3000;

export const isPendingAuthorizationCase = (serviceCase = {}) => (
  get(serviceCase, 'state') === 'pending_authorization'
);

export const isPendingAuthorizationCaseFromAnotherProvider = (
  serviceCase = {},
  currentProviderId = '',
) => {
  const caseProviderId = get(serviceCase, 'provider.id', '');

  return (
    isPendingAuthorizationCase(serviceCase) &&
    !!currentProviderId &&
    !!caseProviderId &&
    !isEqual(caseProviderId, currentProviderId)
  );
};

export const shouldBlockPendingAuthorizationCaseAccess = ({
  serviceCase = {},
  currentProviderId = '',
  isCaseManager = false,
} = {}) => (
  isPendingAuthorizationCase(serviceCase) && (
    isCaseManager ||
    isPendingAuthorizationCaseFromAnotherProvider(serviceCase, currentProviderId)
  )
);
